<tiptap-editor [editor]="editor" [(ngModel)]="value"></tiptap-editor>

<!-- <tiptap-floating-menu [editor]="editor">
    <app-text-editor-toolbar [editor]="editor" />
</tiptap-floating-menu> -->

<!-- <tiptap-bubble-menu [editor]="editor">
    <app-text-editor-toolbar [editor]="editor" />
</tiptap-bubble-menu> -->